import React from 'react';
import './loading.css';

const Loading = () => {
    return (
        <div className="loading-container">
            <div className="loading-overlay">

                <div className="sun-glow"></div>

                <div className="pyramids">
                    <div className="pyramid p1"></div>
                    <div className="pyramid p2"></div>
                    <div className="pyramid p3"></div>
                </div>

                <h1 className="loading-title">
                    TRAVELEXPO <span>CAIRO 2026</span>
                </h1>

                <div className="loading-bar">
                    <div className="loading-progress"></div>
                </div>

                <p className="loading-text">Preparing your experience...</p>

            </div>
        </div>
    );
};

export default Loading;